import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import AssignOffCanvance from "../AssignDeliveryBoy";
import ProductModal from "../ProductModal";
import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import ProductReturnModal from "../ProductReturnModal";
import search1 from "../../../assets/icons/search.png";
import ReturnReson from "../ReturnReson";
import Loader from "../../../common/Loader/Loader";
import ModalSave from "../../../common/ModelSave";
import AssignPickupBoy from "../deliverydetails";
function ReturnTable({
  user,
  OrderByOptions,
  GetAllCounts,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  statusCount,
  activeTab,
  handleTabClick,
  return_status_id,
  setReturnStatus,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [showPickupModal, setShowPickupModal] = useState({ show: 0, data: {} });

  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();

  const [productCategory, setProductCategory] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchCustomer, setSearchCustomer] = useState("");

  const [loading, setLoading] = useState(false);

  const getDataAll = async () => {
    setLoading(true);
    const response = await getData(
      `/admin/orders/return-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&return_status_id=${
        return_status_id || ""
      }&from=${searchDateFrom || ""}&to=${searchDateTo || ""}&customer=${
        searchCustomer || ""
      }&customer_contact=${searchCustomerContact || ""}`,
    );
    await setData(response);
    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange, return_status_id]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const [showRejectReason, setShowRejectReason] = useState({
    show: 0,
    data: {},
  });

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  // const ChangeOrderStatus = async (id, status_id) => {
  //   try {
  //     // Send the POST request to update the store's status
  //     const response = await postData(
  //       `/admin/orders/product-order/return-status/${id}`,
  //       {
  //         order_status_id: status_id,
  //       },
  //     );

  //     if (response?.success) {
  //       await setShowModal({
  //         code: response.code,
  //         message: response.data || response.message,
  //       });
  //       await getDataAll();
  //       await GetAllCounts();
  //     } else {
  //       await setShowModal({ code: response?.code, message: response?.errors });
  //     }

  //     setTimeout(() => {
  //       setShowModal(0);
  //     }, 4000);
  //   } catch (error) {
  //     console.error("Error updating store status:", error);
  //   }
  // };

  const ChangeOrderStatus = async (id, status_id, extraData = {}) => {
    try {
      const response = await postData(
        `/admin/orders/product-order/return-status/${id}`,
        {
          order_status_id: status_id,
          ...extraData,
        },
      );

      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response.data || response.message,
        });
        setTimeout(() => setShowModal(0), 3000);
        await getDataAll();
        await GetAllCounts();
      } else {
        setShowModal({ code: response?.code, message: response?.errors });
        setTimeout(() => setShowModal(0), 3000);
      }
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);
  return (
    <section className="pending-table_holder">
      <section className="pending-table_holder">
        <div className="filter-tabs-container">
          <div className="tabs">
            <button
              className={`waiting-tab ${
                activeTab === "ReturnRequested" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("ReturnRequested");
                setReturnStatus(ReturnStatusIds.ReturnRequested);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.ReturnRequested}</span> Return Requested
            </button>
            <button
              className={`waiting-tab ${
                activeTab === "ReturnScheduled" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("ReturnScheduled");
                setReturnStatus(ReturnStatusIds.PickupScheduled);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.ReturnPickupScheduled}</span> Pickup Scheduled
            </button>
            <button
              className={`waiting-tab ${
                activeTab === "ItemPicked" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("ItemPicked");
                setReturnStatus(ReturnStatusIds.ItemPicked);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.ReturnItemPicked}</span> Item Picked
            </button>
            <button
              className={`waiting-tab ${
                activeTab === "returned" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("returned");
                setReturnStatus(ReturnStatusIds.Returned);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.Returned}</span> Returned
            </button>
            <button
              className={`waiting-tab ${
                activeTab === "ReturnRejetcted" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("ReturnRejetcted");
                setReturnStatus(ReturnStatusIds.ReturnRejected);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.ReturnRejected}</span> Rejected
            </button>

            <button
              className={`waiting-tab ${
                activeTab === "ReturnRefunded" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("ReturnRefunded");
                setReturnStatus(ReturnStatusIds.Refunded);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.Refunded}</span> Refunded
            </button>
          </div>
        </div>
      </section>
      {/* Quick Filters Section */}
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end mb-3">
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  min={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
              <div className="Search me-2">
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  Search
                </Button>
              </div>
              <div className="Search-1">
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setProductCategory("");
                    setSearchCustomer("");
                    setSearchCustomerContact("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br></br>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Order Date</th>
              <th>Order details</th>
              {/* <th>Store details</th> */}
              <th>Products</th>
              <th>Total</th>
              <th>Delivery Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="text-center py-5">
                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{ width: "3rem", height: "3rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>

                  <div className="mt-2">Loading orders...</div>
                </td>
              </tr>
            ) : (
              data?.data?.data?.map((item, index) => (
                <tr key={index}>
                  <td className="order-details">{index + 1}</td>
                  <td className="order-date">
                    <div className="order-id">
                      {calculateTimeAgo(item?.Product_Order?.createdAt)}
                    </div>
                    <div className="order-info">
                      <span>
                        {
                          new Date(item?.Product_Order?.createdAt)
                            .toISOString()
                            .split("T")[0]
                        }
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {formatTimeInIST(item?.Product_Order?.createdAt)} IST
                      </span>
                    </div>
                  </td>

                  {/* Owner Details */}
                  <td className="order-details">
                    <div className="order-id text-highlight">
                      {item?.Product_Order?.invoice_no}
                    </div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Name</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="text-highlight">
                        {item?.Product_Order?.User?.name}
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="order-info">
                        {item?.Product_Order?.User?.contact_no}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>{item?.Product_Order?.Payment_Type?.name}</span>
                    </div>

                    {/* <div className="order-info">
                    <span>{item?.Product_Order?.user?.type}</span>
                  </div> */}
                  </td>

                  <td className="order-details">
                    {item?.Return_Order_Details?.map((product, index) => (
                      <>
                        <div className="index_div">
                          <p className="index_no"> {index + 1})</p>
                          <div className="all_data">
                            <div className="text-highlight">
                              <span>
                                <b>Product Name </b>
                              </span>
                              :
                              <span>
                                {" "}
                                {product?.Product_Order_Detail?.Product?.name}
                              </span>
                            </div>
                            <div className="order-info">
                              <span>
                                <b>Category Name </b>
                              </span>
                              :
                              <span>
                                {" "}
                                {
                                  product?.Product_Order_Detail?.Product
                                    ?.p_category?.name
                                }{" "}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* <div className="text-highlight">
                          <span>
                            {product?.Product_Order_Detail?.Product?.name}
                          </span>
                        </div>
                        <div className="order-info">
                          <span>
                            {
                              product?.Product_Order_Detail?.Product?.p_category
                                ?.name
                            }{" "}
                          </span>
                        </div> */}
                      </>
                    ))}
                    <div></div>
                    <div className=" mt-3">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          setShowDetails({
                            show: item?.Product_Order?.id,
                            data: item?.Return_Order_Details,
                          })
                        }
                      >
                        View All Details
                      </Button>
                    </div>
                  </td>

                  <td className="order-details more_space">
                    <div className="order-id">
                      <span>
                        <b>Total SubTotal</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_selling_price).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Delivery Charges</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.delivery_charges).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Offer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.total_offer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Coupon Discount</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_coupon_discount).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Refer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.refer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Total Tax</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_tax).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Grand Total</b>
                      </span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_amount).toFixed(2)} /-
                      </span>
                    </div>
                  </td>

                  <td>
                    <div className="text-highlight">
                      <span>
                        {[
                          item?.Product_Order?.User_Address?.first_name,
                          item?.Product_Order?.User_Address?.last_name,
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>
                        {[
                          item?.Product_Order?.User_Address?.floor
                            ? `${item?.Product_Order?.User_Address.floor} floor`
                            : null,
                          item?.Product_Order?.User_Address?.building,
                          item?.Product_Order?.User_Address?.apartment,
                          item?.Product_Order?.User_Address?.street,
                          item?.Product_Order?.User_Address?.society,
                          item?.Product_Order?.User_Address?.area,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>
                        {[
                          item?.Product_Order?.User_Address
                            ?.Users_Address_Detail?.Country?.name,
                          item?.Product_Order?.User_Address
                            ?.Users_Address_Detail?.State?.name,
                          item?.Product_Order?.User_Address
                            ?.Users_Address_Detail?.City?.name,
                          item?.Product_Order?.User_Address
                            ?.Users_Address_Detail?.Area?.name,
                          item?.Product_Order?.User_Address
                            ?.Users_Address_Detail?.Pincode?.name,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </span>
                    </div>

                    {item?.Product_Order?.User_Address?.address_type && (
                      <div className="order-info">
                        <span>
                          {item?.Product_Order?.User_Address.address_type}
                        </span>
                      </div>
                    )}

                    {item?.Product_Order?.User_Address?.contact_no && (
                      <div className="text-highlight">
                        <span>
                          {item?.Product_Order?.User_Address.contact_no}
                        </span>
                      </div>
                    )}

                    {item?.message && (
                      <div className="order-info">
                        <span>
                          <b>Return Message</b>
                        </span>{" "}
                        : <span>{item?.message}</span>
                      </div>
                    )}

                    {item?.Return_Reason?.name && (
                      <div className="text-highlight">
                        <span>
                          <b>Return Reason</b>
                        </span>{" "}
                        :<span>{item?.Return_Reason?.name} </span>
                      </div>
                    )}

                    {item?.reason && (
                      <div className="text-highlight">
                        <span>
                          <b>Reject Reason</b>
                        </span>{" "}
                        :<span>{item?.reason} </span>
                      </div>
                    )}

                    <div>
                      {item?.delivery_boy_name && (
                        <>
                          <strong>Delivery Partner : </strong>
                          <span>{item.delivery_boy_name}</span>
                        </>
                      )}
                    </div>

                    <div>
                      {item?.delivery_boy_number && (
                        <>
                          <strong>Delivery Partner's Number : </strong>
                          <span>{item.delivery_boy_number}</span>
                        </>
                      )}
                    </div>
                  </td>

                  <td>
                    <div>
                      <p className="status-holder shipped">
                        {item?.Return_Status?.name}
                      </p>
                    </div>
                  </td>
                  <td>
                    <td>
                      {Number(item?.return_status_id) ===
                      Number(ReturnStatusIds.ReturnRequested) ? (
                        <div className="my-1">
                          {/* <Button
                            className="action-btn active mt-3"
                            onClick={() =>
                              ChangeOrderStatus(
                                item?.id,
                                ReturnStatusIds.PickupScheduled,
                              )
                            }
                          >
                            Send PickUp Scheduled
                          </Button> */}
                          <Button
                            className="action-btn active mb-2"
                            onClick={() =>
                              setShowPickupModal({ show: item?.id, data: item })
                            }
                          >
                            Send PickUp Scheduled
                          </Button>

                          <Button
                            className="action-btn active mb-2"
                            onClick={() =>
                              setShowRejectReason({
                                show: item?.id,
                                data: item,
                              })
                            }
                          >
                            Reject Order
                          </Button>
                        </div>
                      ) : Number(item?.return_status_id) ===
                        Number(ReturnStatusIds.PickupScheduled) ? (
                        <div className="my-1">
                          <Button
                            className="action-btn active"
                            onClick={() =>
                              ChangeOrderStatus(
                                item?.id,
                                ReturnStatusIds.ItemPicked,
                              )
                            }
                          >
                            Send Item Picked
                          </Button>
                        </div>
                      ) : item?.return_status_id ===
                        ReturnStatusIds.ItemPicked ? (
                        <div className="my-1">
                          <Button
                            className="action-btn active mb-2"
                            onClick={() =>
                              ChangeOrderStatus(
                                item?.id,
                                ReturnStatusIds.Returned,
                              )
                            }
                          >
                            Send Returned
                          </Button>
                          <br></br>
                          <Button
                            className="action-btn active"
                            onClick={() =>
                              setShowRejectReason({
                                show: item?.id,
                                data: item,
                              })
                            }
                          >
                            Reject Order
                          </Button>
                        </div>
                      ) : item?.return_status_id ===
                        ReturnStatusIds.Returned ? (
                        <div className="my-1">
                          <Button
                            className="action-btn active"
                            onClick={() =>
                              ChangeOrderStatus(
                                item?.id,
                                ReturnStatusIds.Refunded,
                              )
                            }
                          >
                            Send Refunded
                          </Button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </td>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>
      {/* <AssignReturnOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      /> */}
      <AssignReturnOffCanvance
        handleClose={() => {
          setShowReturnAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowReturnAssign({ show: 0, data: {} })}
        show={showReturnAssign?.show}
        data={showReturnAssign?.data}
      />
      <ProductReturnModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />

      <ReturnReson
        GetAllCounts={GetAllCounts}
        getDataAll={getDataAll}
        handleClose={() => {
          setShowRejectReason({ show: 0, data: {} });
        }}
        setShow={() => setShowRejectReason({ show: 0, data: {} })}
        show={showRejectReason?.show}
        data={showRejectReason?.data}
      />
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <AssignPickupBoy
        show={showPickupModal?.show}
        data={showPickupModal?.data}
        handleClose={() => setShowPickupModal({ show: 0, data: {} })}
        onConfirm={async (id, extraData) => {
          await ChangeOrderStatus(
            id,
            ReturnStatusIds.PickupScheduled,
            extraData,
          );
        }}
      />
    </section>
  );
}

export default ReturnTable;
